'use strict';

exports.__esModule = true;
exports.findViewerItem = findViewerItem;
exports.findViewerItemArea = findViewerItemArea;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createId = require('./utils/createId');

var _createId2 = _interopRequireDefault(_createId);

var _constants = require('./constants');

require('./ViewerItem.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// singleton object holding all existing ViewerItems
var viewerItems = {};

var ViewerItem = function (_PureComponent) {
  _inherits(ViewerItem, _PureComponent);

  function ViewerItem(props) {
    _classCallCheck(this, ViewerItem);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.id = (0, _createId2.default)();
    viewerItems[_this.id] = _this;
    return _this;
  }

  ViewerItem.prototype.componentWillUnmount = function componentWillUnmount() {
    delete viewerItems[this.id];
  };

  ViewerItem.prototype.render = function render() {
    var _itemToScreen = this.itemToScreen(this.props.item, this.props.yUnitToScreen, this.props.xUnitToScreen),
        top = _itemToScreen.top,
        left = _itemToScreen.left,
        width = _itemToScreen.width,
        height = _itemToScreen.height;

    var style = Object.assign({}, this.props.style, { left: left, top: top, width: width, height: height });
    var movement = typeof this.props.movement === 'number' ? this.props.movement : _constants.MOVE_ALL;

    var canMoveHorizontalOrVertical = (movement & _constants.MOVE_HORIZONTAL) === _constants.MOVE_HORIZONTAL || (movement & _constants.MOVE_VERTICAL) === _constants.MOVE_VERTICAL || (movement & _constants.MOVE_CENTER) === _constants.MOVE_CENTER;

    var className = 'viewer-item ' + (canMoveHorizontalOrVertical ? '' : 'viewer-item-fixed ') + (this.props.className || '');

    // TODO: don't render when not in the visible area (must be optional of course)

    return _react2.default.createElement(
      'div',
      { 'data-viewer-item-id': this.id,
        'data-viewer-item-area': 'center',
        className: className,
        style: style },
      this.props.children,
      this.renderLeft(movement),
      this.renderRight(movement),
      this.renderTop(movement),
      this.renderBottom(movement)
    );
  };

  ViewerItem.prototype.renderLeft = function renderLeft(movement) {
    return (movement & _constants.MOVE_LEFT) !== 0 ? _react2.default.createElement('div', { 'data-viewer-item-area': 'left',
      className: 'viewer-item-left' }) : null;
  };

  ViewerItem.prototype.renderRight = function renderRight(movement) {
    return (movement & _constants.MOVE_RIGHT) !== 0 ? _react2.default.createElement('div', { 'data-viewer-item-area': 'right',
      className: 'viewer-item-right' }) : null;
  };

  ViewerItem.prototype.renderTop = function renderTop(movement) {
    return (movement & _constants.MOVE_TOP) !== 0 ? _react2.default.createElement('div', { 'data-viewer-item-area': 'top',
      className: 'viewer-item-top' }) : null;
  };

  ViewerItem.prototype.renderBottom = function renderBottom(movement) {
    return (movement & _constants.MOVE_BOTTOM) !== 0 ? _react2.default.createElement('div', { 'data-viewer-item-area': 'bottom',
      className: 'viewer-item-bottom' }) : null;
  };

  // TODO: move the itemToScreen function into a separate file, and expose it as util function (and add some tests)
  /**
   * Calculate the position of an item on screen, given an item with
   * start/end time and start/end number.
   * @param {{yStart: Date, yEnd: Date, xStart: number, xEnd: number}} item
   * @param {function(Date): number} yUnitToScreen
   * @param {function(number): number} xUnitToScreen
   * @returns {{top: number, bottom: number, height: number, left: number, right: number, width: number}}
   */


  ViewerItem.prototype.itemToScreen = function itemToScreen(item, yUnitToScreen, xUnitToScreen) {
    // TODO: check whether all required properties are available, if not, don't render and log a warning
    var top = yUnitToScreen(item.yStart);
    var bottom = yUnitToScreen(item.yEnd);
    var start = xUnitToScreen(item.xStart);
    var end = xUnitToScreen(item.xEnd);
    var left = Math.min(start, end);
    var right = Math.max(start, end);
    var width = right - left;
    var height = bottom - top;

    return { top: top, bottom: bottom, height: height, left: left, right: right, width: width };
  };

  return ViewerItem;
}(_react.PureComponent);

/**
 * Find a ViewerItem from an event target (if any
 * @param {Event.target} target
 * @returns {ViewerItem | null}
 */


ViewerItem.propTypes = {
  item: _propTypes2.default.shape({
    yStart: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.instanceOf(Date)]).isRequired,
    yEnd: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.instanceOf(Date)]).isRequired,
    xStart: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.instanceOf(Date)]).isRequired,
    xEnd: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.instanceOf(Date)]).isRequired
  }).isRequired,

  movement: _propTypes2.default.number,

  className: _propTypes2.default.string,
  style: _propTypes2.default.object
};
exports.default = ViewerItem;
function findViewerItem(target) {
  var elem = target;
  while (elem && elem.getAttribute) {
    var id = elem.getAttribute('data-viewer-item-id');
    if (id && viewerItems[id]) {
      return viewerItems[id];
    }

    elem = elem.parentNode;
  }

  return null;
}

/**
 * Find the area where a viewer item is being dragged
 * @param {Event.target} target
 * @returns {'center' | 'left' | 'right' | 'top' | 'bottom' | null}
 */
function findViewerItemArea(target) {
  var elem = target;
  while (elem && elem.getAttribute) {
    var area = elem.getAttribute('data-viewer-item-area');
    if (area) {
      return area;
    }

    elem = elem.parentNode;
  }

  return null;
}